import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import adminWorkgroupApi from "../../api/admin/AdminWorkgroup";
import {
  WorkgroupDetailDTO,
  WorkgroupRespDto,
  WorkgroupSearchDto,
} from "../../../types/workgroup";
import {
  ChangeManagerRequestDto,
  ChangeWorkgroupStatusReuqestDto,
  DownloadContentRequestDto,
} from "../../../types/adminWorkgroup";
import { DocumentListReq, DocumentListResp } from "../../../types/files";
import { getAdminInfoFromLocalStorage } from "../../../shared/utils/auth";
import FileSaver from "file-saver";

// # initial state
const initialState = {
  usingWorkgroup: {} as WorkgroupRespDto,
  deleteWorkgroup: {} as WorkgroupRespDto,
  workgroupDetail: {} as WorkgroupDetailDTO,
  contentList: {} as DocumentListResp,
};

export const trunkGetWorkgroupList = createAsyncThunk(
  "wapi/admins/workgroups/paging",
  async (logSearchOptions: WorkgroupSearchDto) => {
    const resp = await adminWorkgroupApi.getWorkgroupList(logSearchOptions);
    return resp;
  }
);
export const trunkGetDeletedWorkgroupList = createAsyncThunk(
  "wapi/admins/workgroups/paging/delete",
  async (logSearchOptions: WorkgroupSearchDto) => {
    const resp = await adminWorkgroupApi.getWorkgroupList(logSearchOptions);
    return resp;
  }
);
export const trunkChangeWorkgroupStatus = createAsyncThunk(
  "wapi/admins/workgroups/status",
  async (logSearchOptions: ChangeWorkgroupStatusReuqestDto) => {
    const resp = await adminWorkgroupApi.changeWorkgroupStatus(
      logSearchOptions
    );
    return resp;
  }
);
export const trunkGetWorkgroupDetail = createAsyncThunk(
  "wapi/workgroups/admin",
  async (workgroupId: string) => {
    const resp = await adminWorkgroupApi.getWorkgroupDetail(workgroupId);
    return resp;
  }
);
export const trunkGetContentList = createAsyncThunk(
  "wapi/admins/contents/list",
  async (logSearchOptions: DocumentListReq) => {
    const resp = await adminWorkgroupApi.getContentList(logSearchOptions);
    return resp;
  }
);
export const trunkDownloadContent = createAsyncThunk(
  "wapi/admins/contents/download",
  async (searchOptions: DownloadContentRequestDto) => {
    const resp = await adminWorkgroupApi.downloadContent(searchOptions);
    return resp;
  }
);
export const trunkChangeManager = createAsyncThunk(
  "wapi/admins/workgroups/manager",
  async (searchOptions: ChangeManagerRequestDto) => {
    const resp = await adminWorkgroupApi.changeManager(searchOptions);
    return resp;
  }
);

const adminWorkgroupSlice = createSlice({
  name: "adminWorkgroup",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      trunkGetWorkgroupList.fulfilled,
      (state, { payload: newLogList }) => {
        state.usingWorkgroup = newLogList;
      }
    );

    builder.addCase(
      trunkGetDeletedWorkgroupList.fulfilled,
      (state, { payload: newLogList }) => {
        state.deleteWorkgroup = newLogList;
      }
    );
    builder.addCase(
      trunkGetWorkgroupDetail.fulfilled,
      (state, { payload: newWorkgroupDetail }) => {
        state.workgroupDetail = newWorkgroupDetail;
      }
    );
    builder.addCase(
      trunkGetContentList.fulfilled,
      (state, { payload: newContentList }) => {
        state.contentList = newContentList;
      }
    );
    builder.addCase(
      trunkDownloadContent.fulfilled,
      (state, { payload: res }) => {
        const loginResult = getAdminInfoFromLocalStorage();
        if (res.data && res.headers && loginResult) {
          const file = res.data;
          const header = res.headers;
          const regex =
            /filename[^;=\n]*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/i;
          const contentDisposition =
            header["content-disposition"].match(regex)[0];
          let fileName = contentDisposition.split("filename=");
          fileName = decodeURIComponent(fileName[1]);

          FileSaver.saveAs(file, fileName);
        }
      }
    );
    builder.addCase(
      trunkChangeManager.fulfilled,
      (state, { payload: newWorkgroupInfo }) => {
        let checkIsMangerInWorkgroup =
          state.workgroupDetail.workgroup.members?.filter(
            (item1) => item1.userId === newWorkgroupInfo.managerId
          ).length === 0;
        state.workgroupDetail.workgroup.managerId = newWorkgroupInfo.managerId;
        state.usingWorkgroup.workgroupList.filter((item) => {
          if (item.workgroupId === newWorkgroupInfo.workgroupId) {
            item.managerId = newWorkgroupInfo.managerId;
            item.managerName = newWorkgroupInfo.managerName;
            checkIsMangerInWorkgroup && item.internalUserCount++;
          }
        });
      }
    );
  },
});

export const adminWorkgroupActions = adminWorkgroupSlice.actions;
export default adminWorkgroupSlice.reducer;
